import localforage from "localforage";
import reject from "lodash/reject";
import { phpRequest } from "./phpRequest";

export const generateRecursiveList = (json = [], loadUsers) => {
  let treeData = [];
  if (json) {
    json.map((res, index) => {
      if (Array.isArray(res.children) && res.children.length > 0) {
        treeData.push({
          title: res.name,
          name: res.name,
          key: res.id,
          parent_id: res.parent_company_id,
          checkable: loadUsers ? false : undefined,
          isLeaf: false,
          children: generateRecursiveList(res.children, loadUsers)
        });
      } else {
        treeData.push({
          title: res.name,
          name: res.name,
          key: res.id,
          parent_id: res.parent_company_id,
          checkable: loadUsers ? false : undefined,
          isLeaf: false
          // isLeaf: loadUsers ? false : true // means the last layer
        });
      }
      return treeData;
    });
  }

  return treeData;
};

export const flatMultiDimensional = array => {
  let result = [];
  if (array) {
    array.forEach(function (a) {
      result.push(a);
      if (Array.isArray(a.children)) {
        result = result.concat(flatMultiDimensional(a.children));
      }

      // delete a.children;
    });
  }

  return result;
};

export async function getCompanyTreeAPI(loadUsers) {
  const companyId = await localforage.getItem("userCompanyID");
  const user = await localforage.getItem("user");
  const data = await phpRequest.get("/company-tree", {
    company_id: companyId,
    user_id: user.id
  });
  if (data && data.companies) {
    const companyTreeArr = generateRecursiveList(data.companies, loadUsers);
    const flattenSubCompaniesArr = flatMultiDimensional(data.companies);
    const flattenCompanyTreeWithoutHQ = reject(
      flattenSubCompaniesArr,
      function (o) {
        return !o.parent_company_id;
      }
    );

    return {
      companyTree: companyTreeArr,
      flattenCompanyTree: flattenSubCompaniesArr,
      flattenCompanyTreeWithoutHQ
    };
  }
  return {
    companyTree: [],
    flattenCompanyTree: [],
    flattenCompanyTreeWithoutHQ: []
  };
}

export function getCompanyAccounts(params) {
  return phpRequest.get("/company/accounts", params);
}
